import {
  getRuntimeEnvironmentName,
  normalizeEnvironmentName,
} from '@/config/urls';
import type { AppShellEnvironment } from '@/shell/AppShellContext';

export function mapRuntimeEnvironmentToAppShell(
  runtimeName: string | undefined,
): AppShellEnvironment {
  return normalizeEnvironmentName(runtimeName);
}

export function resolveDeploymentEnvironment(): AppShellEnvironment {
  const runtimeName = window.environment?.name;

  if (runtimeName) {
    return mapRuntimeEnvironmentToAppShell(runtimeName);
  }

  return mapRuntimeEnvironmentToAppShell(import.meta.env.MODE);
}

export const resolveRuntimeEnvironment = getRuntimeEnvironmentName;
